import * as actions from '~/domains/customization/actions';

const resolve = async ({ dispatch, params: { pagePath } }) => {
  dispatch(actions.setCustomizationHeader({ isDraft: false }));

  await dispatch(actions.fetchCustomPageHTML(pagePath));
};

export default resolve;
